import React, { useEffect, useRef } from 'react';
import Clientlogos from '../components/logosloop';

import Workprocess from '../components/Workprocess'
import Form from '../components/form';



const Pricing = () => {
 const canvasRef = useRef(null);
    const mousePosRef = useRef(null);
    const pointsRef = useRef([]);
    const animationRef = useRef(null);
  
    const maxDist = 200;
    const colour = "#FFFFFF";
  
    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
  
      // Point constructor
      class Point {
        constructor() {
          this.x = (Math.random() * (canvas.width + maxDist)) - (maxDist / 2);
          this.y = (Math.random() * (canvas.height + maxDist)) - (maxDist / 2);
          this.vx = (Math.random() * 2) - 1;
          this.vy = (Math.random() * 2) - 1;
          this.dia = Math.random() * 3 + 1;
        }
      }
  
      // Generate points
      const generatePoints = (amount) => {
        pointsRef.current = [];
        for (let i = 0; i < amount; i++) {
          pointsRef.current.push(new Point());
        }
      };
  
      // Draw function
      const draw = (obj) => {
        ctx.beginPath();
        ctx.fillStyle = colour;
        if (obj.dia) {
          ctx.arc(obj.x, obj.y, obj.dia, 0, 2 * Math.PI);
        } else {
          ctx.arc(obj.x, obj.y, 2, 0, 2 * Math.PI);
        }
        ctx.closePath();
        ctx.fill();
      };
  
      // Update function
      const update = (obj) => {
        obj.x += obj.vx;
        obj.y += obj.vy;
        if (obj.x > canvas.width + (maxDist / 2)) {
          obj.x = -(maxDist / 2);
        } else if (obj.x < -(maxDist / 2)) {
          obj.x = canvas.width + (maxDist / 2);
        }
        if (obj.y > canvas.height + (maxDist / 2)) {
          obj.y = -(maxDist / 2);
        } else if (obj.y < -(maxDist / 2)) {
          obj.y = canvas.height + (maxDist / 2);
        }
      };
  
      // Collision detection and line drawing
      const collision = (obj, dist) => {
        let temp;
        for (let i = 0; i < pointsRef.current.length; i++) {
          if (obj !== pointsRef.current[i]) {
            temp = Math.sqrt(
              Math.pow((obj.x - pointsRef.current[i].x), 2) + 
              Math.pow((obj.y - pointsRef.current[i].y), 2)
            );
            if (temp < dist) {
              ctx.beginPath();
              ctx.moveTo(obj.x, obj.y);
              ctx.strokeStyle = `rgba(255,255,255,${0.8 * Math.pow((dist - temp) / dist, 5)})`;
              ctx.moveTo(obj.x, obj.y);
              ctx.lineTo(pointsRef.current[i].x, pointsRef.current[i].y);
              ctx.closePath();
              ctx.stroke();
            }
          }
        }
      };
  
      // Main animation loop
      const pointFun = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (mousePosRef.current) {
          collision(mousePosRef.current, maxDist * 2);
          draw(mousePosRef.current);
        }
        for (let i = 0; i < pointsRef.current.length; i++) {
          collision(pointsRef.current[i], maxDist);
          draw(pointsRef.current[i]);
          update(pointsRef.current[i]);
        }
      };
  
      // Resize canvas
      const resizeCanvas = () => {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = window.innerHeight;
        generatePoints(170);
        pointFun();
      };
  
      // Mouse move handler
      const handleMouseMove = (evt) => {
        const rect = canvas.getBoundingClientRect();
        mousePosRef.current = {
          x: evt.clientX - rect.left,
          y: evt.clientY - rect.top
        };
      };
  
      // Initialize
      resizeCanvas();
      pointFun();
  
      // Start animation
      const interval = setInterval(pointFun, 16);
      animationRef.current = interval;
  
      // Event listeners
      window.addEventListener('resize', resizeCanvas);
      canvas.addEventListener('mousemove', handleMouseMove);
  
      // Cleanup
      return () => {
        clearInterval(interval);
        window.removeEventListener('resize', resizeCanvas);
        canvas.removeEventListener('mousemove', handleMouseMove);
      };
    }, []);
  
    return (
      <div style={{ 
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100vw',
        position: 'relative',
        paddingTop: '130px'
      }}>
        <div style={{ 
          margin: 0, 
          padding: 0, 
          overflow: 'hidden',
          width: '100%',
          height: '60vh',
          position: 'relative'
        }}>
          <canvas
            ref={canvasRef}
            id="canvas"
            style={{
              overflow: 'hidden',
              cursor: 'none',
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'linear-gradient(to bottom, #306873, #52A7B0)'
            }}
          />
          <div style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            zIndex: 1
          }}>
            <h2 style={{
              color: '#ffffff',
              fontSize: '3rem',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
              maxWidth: '900px',
              margin: '0 auto'
            }}>
              <span className="workdeskva-brand"><span className="workdeskva-bold">Work</span> <span className="workdeskva-light">Desk</span> <span>VA</span></span> Remote Staffing Pricing
            </h2>
            <p style={{
              color: '#ffffff',
              fontSize: '1.25rem',
              marginTop: '1rem',
              textShadow: '1px 1px 2px rgba(0,0,0,0.3)',
              maxWidth: '700px',
              margin: '1rem auto 0'
            }}>
              Save up to 70% on your operational costs with our professional remote staffing solutions. Get started with flexible, cost-effective talent today.
            </p>
          </div>
        </div>

      
      <Clientlogos />
      <Form/>
        <Workprocess />
      
    </div>
  );
};

export default Pricing;
